import { IHistoricalTeam } from 'src/app/shared/models/team/ihistoricalTeam';

export class HistoricalTeamWrite implements IHistoricalTeam {
  public name: string;
  public positionTitle: string;
  public startDate: Date;
  public endDate: Date;

  constructor(historicalTeamWrite: any = undefined) {
    if (historicalTeamWrite) this.setProperties(historicalTeamWrite);
  }

  private setProperties(historicalTeamWrite: any) {
    this.name = historicalTeamWrite.name;
    this.positionTitle = historicalTeamWrite.positionTitle;
    this.startDate = historicalTeamWrite.startDate;
    this.endDate = historicalTeamWrite.endDate;
  }
}
